import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { takeUntil } from "rxjs/operators";
import { GeneralLedgerVoucherFormComponent } from "../general-ledger-voucher-form/general-ledger-voucher-form.component";

@Component({
  selector: "ngx-general-ledger-voucher-list",
  templateUrl: "./general-ledger-voucher-list.component.html",
  styleUrls: ["./general-ledger-voucher-list.component.scss"],
})
export class GeneralLedgerVoucherListComponent extends BaseListComponent {
  filterInfo: NameValue[] = [];
  constructor() {
    super();
    this.inputEditorform = GeneralLedgerVoucherFormComponent;
  }
  ngOnInit() {
    this.apiName = "GeneralLedgerVoucherHeader";
    this.areaName = "Accounting";
    this.label = "سند کل";
    if (this.accountService.authService.currentFiscalYear) {
      this.filterInfo.push({ Name: "FiscalYearId", Value: this.accountService.authService.currentFiscalYear?.Id, Operator: "eq" });
      this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.filterInfo.push({ Name: "FiscalYearId", Value: x.Id, Operator: "eq" });
          this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
        }
      });
  }
}
